var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 5.20866C10.3445 5.20866 10.6243 5.48848 10.6243 5.83366V10.8337C10.6243 11.1788 10.3445 11.4587 9.99935 11.4587C9.65417 11.4587 9.37435 11.1788 9.37435 10.8337V5.83366C9.37435 5.48848 9.65417 5.20866 9.99935 5.20866Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 14.167C10.4596 14.167 10.8327 13.7939 10.8327 13.3337C10.8327 12.8734 10.4596 12.5003 9.99935 12.5003C9.53911 12.5003 9.16602 12.8734 9.16602 13.3337C9.16602 13.7939 9.53911 14.167 9.99935 14.167Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04102 10.0003C1.04102 5.05278 5.0518 1.04199 9.99935 1.04199C14.9469 1.04199 18.9577 5.05278 18.9577 10.0003C18.9577 14.9479 14.9469 18.9587 9.99935 18.9587C5.0518 18.9587 1.04102 14.9479 1.04102 10.0003ZM9.99935 2.29199C5.74215 2.29199 2.29102 5.74313 2.29102 10.0003C2.29102 14.2575 5.74215 17.7087 9.99935 17.7087C14.2565 17.7087 17.7077 14.2575 17.7077 10.0003C17.7077 5.74313 14.2565 2.29199 9.99935 2.29199Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/errorCircle.8ed88f35afce8eecad78375df6a07b21.svg";
export { ForwardRef as ReactComponent };